import { render, staticRenderFns } from "./6ActivitateAlteDetalii.vue?vue&type=template&id=7000ebce"
import script from "./6ActivitateAlteDetalii.vue?vue&type=script&lang=js"
export * from "./6ActivitateAlteDetalii.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports